.buttonReset {
	all: unset;
	cursor: pointer;
	display: flex;
	height: fit-content;
	width: fit-content;
}

.tooltip {
	padding: 12px;
	background-color: var(--background-secondary);
	color: var(--content-secondary);
	border-radius: 8px;
	max-width: 320px;
	composes: body-2 from global;
	margin: 8px;
}
